import api from './api';

export const publishingIdentityFields = identityId => identityId
    ? { publishing_identity_id: identityId }
    : {};

// Public forum API (no auth)
export const forumPublicApi = {
    getCategories: () => api.get('/public/forum/categories'),
    getStats: () => api.get('/public/forum/stats'),
    search: (query) => api.get(`/public/forum/search?q=${encodeURIComponent(query)}`),
    getBoard: (slug) => api.get(`/public/forum/boards/${slug}`),
    getThreads: (boardSlug, page = 1, sort = 'active') =>
        api.get(`/public/forum/threads/${boardSlug}?page=${page}&sort=${sort}`),
    getThread: (threadSlug, page = 1) =>
        api.get(`/public/forum/thread/${threadSlug}?page=${page}`),
    getRecentPosts: (limit = 5) => api.get(`/public/forum/recent-posts?limit=${limit}`),
    getUserProfile: (username) => api.get(`/public/forum/users/${encodeURIComponent(username)}`),
    downloadAttachment: (id) => api.get(`/public/forum/attachments/${id}`, { responseType: 'blob' }),
    createNotice: (data) => api.post('/public/forum/notices', data),
    getNotice: (id, token) => api.get(`/public/forum/notices/${encodeURIComponent(id)}`, {
        headers: { 'X-Notice-Token': token },
    }),
    appealNotice: (id, token, reason) => api.post(`/public/forum/notices/${encodeURIComponent(id)}/appeal`, { reason }, {
        headers: { 'X-Notice-Token': token },
    }),
};

// Portal forum API (auth required)
export const forumPortalApi = {
    createThread: (data) => api.post('/portal/forum/thread', data),
    replyThread: (threadId, data) => api.post(`/portal/forum/thread/${threadId}/reply`, data),
    editPost: (postId, data) => api.put(`/portal/forum/post/${postId}`, data),
    likePost: (postId) => api.post(`/portal/forum/post/${postId}/like`),
    subscribe: (threadId) => api.post(`/portal/forum/thread/${threadId}/subscribe`),
    myThreads: () => api.get('/portal/forum/my-threads'),
    mySubscriptions: () => api.get('/portal/forum/my-subscriptions'),
    reportPost: (postId, data) => api.post(`/portal/forum/post/${postId}/report`, data),
    votePoll: (threadId, optionIndex) => api.post(`/portal/forum/thread/${threadId}/poll/vote`, { option_index: optionIndex }),
    bestAnswer: (threadId, postId) => api.post(`/portal/forum/thread/${threadId}/best-answer/${postId}`),
    uploadAttachment: (postId, data) => api.post(`/portal/forum/post/${postId}/attachments`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    deleteAttachment: (id) => api.delete(`/portal/forum/attachments/${id}`),
    getNotifications: () => api.get('/portal/forum/notifications'),
    readNotification: (id) => api.post(`/portal/forum/notifications/${id}/read`),
    readAllNotifications: () => api.post('/portal/forum/notifications/read-all'),
    getMessages: (box = 'inbox') => api.get('/portal/forum/messages', { params: { box } }),
    getMessage: (id) => api.get(`/portal/forum/messages/${id}`),
    sendMessage: (data) => api.post('/portal/forum/messages', data),
    deleteMessage: (id) => api.delete(`/portal/forum/messages/${id}`),
    reportMessage: (id, reason) => api.post(`/portal/forum/messages/${id}/report`, { reason }),
};

// Admin forum API
export const forumAdminApi = {
    getPublishingIdentities: () => api.get('/admin/forum/publishing-identities'),
    getCategories: () => api.get('/admin/forum/categories'),
    createCategory: (data) => api.post('/admin/forum/categories', data),
    updateCategory: (id, data) => api.put(`/admin/forum/categories/${id}`, data),
    deleteCategory: (id) => api.delete(`/admin/forum/categories/${id}`),
    getBoards: () => api.get('/admin/forum/boards'),
    createBoard: (data) => api.post('/admin/forum/boards', data),
    updateBoard: (id, data) => api.put(`/admin/forum/boards/${id}`, data),
    deleteBoard: (id) => api.delete(`/admin/forum/boards/${id}`),
    getThreads: (page = 1) => api.get(`/admin/forum/threads?page=${page}`),
    pinThread: (id) => api.put(`/admin/forum/threads/${id}/pin`),
    lockThread: (id) => api.put(`/admin/forum/threads/${id}/lock`),
    solveThread: (id) => api.put(`/admin/forum/threads/${id}/solve`),
    closePoll: (id) => api.put(`/admin/forum/threads/${id}/poll/close`),
    moveThread: (id, boardId) => api.put(`/admin/forum/threads/${id}/move?board_id=${boardId}`),
    deletePost: (id, reason) => api.delete(`/admin/forum/posts/${id}?reason=${encodeURIComponent(reason || 'Moderiert')}`),
    restorePost: (id) => api.put(`/admin/forum/posts/${id}/restore`),
    deleteAttachment: (id) => api.delete(`/admin/forum/attachments/${id}`),
    getReports: (status = 'actionable') => api.get(`/admin/forum/reports?status=${status}`),
    resolveReport: (id, data) => api.put(`/admin/forum/reports/${id}/resolve`, data),
    getStats: () => api.get('/admin/forum/stats'),
    seedDemo: () => api.post('/admin/forum/seed-demo'),
    deleteThread: (id) => api.delete(`/admin/forum/threads/${id}`),
    getForumUsers: () => api.get('/admin/forum/users'),
    setUserRole: (userId, role) => api.put(`/admin/forum/users/${userId}/role?role=${role}`),
    banUser: (userId, days, reason) => api.post(`/admin/forum/users/${userId}/ban?days=${days}&reason=${encodeURIComponent(reason)}`),
    unbanUser: (userId) => api.delete(`/admin/forum/users/${userId}/ban`),
};
